import { render } from "./ExpencesList.vue?vue&type=template&id=486a4f5a&scoped=true"
import script from "./ExpencesList.vue?vue&type=script&lang=js"
export * from "./ExpencesList.vue?vue&type=script&lang=js"

import "./ExpencesList.vue?vue&type=style&index=0&id=486a4f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486a4f5a"]])

export default __exports__